import { Component, Input, OnChanges, OnDestroy, signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Project } from '../../project-data';

const PROJECT_LOADER_DURATION_MS = 3000;

@Component({
  selector: 'app-project-page',
  templateUrl: './project-page.component.html',
})
export class ProjectPageComponent implements OnChanges, OnDestroy {
  @Input({ required: true }) project!: Project;

  protected readonly showProjectLoader = signal(true);
  protected trustedProjectUrl!: SafeResourceUrl;

  private loaderTimeoutId?: number;

  constructor(private readonly sanitizer: DomSanitizer) {}

  ngOnChanges(): void {
    this.trustedProjectUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.project.iframeUrl);
    this.restartProjectLoader();
  }

  ngOnDestroy(): void {
    this.clearLoaderTimeout();
  }

  private restartProjectLoader(): void {
    this.clearLoaderTimeout();
    this.showProjectLoader.set(true);
    this.loaderTimeoutId = window.setTimeout(() => {
      this.showProjectLoader.set(false);
      this.loaderTimeoutId = undefined;
    }, PROJECT_LOADER_DURATION_MS);
  }

  private clearLoaderTimeout(): void {
    if (this.loaderTimeoutId === undefined) {
      return;
    }

    window.clearTimeout(this.loaderTimeoutId);
    this.loaderTimeoutId = undefined;
  }
}
